
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetobhimashankarcab() {



    const cardData =
    {
        keyword: '  Pune to Bhimashankar Cab',
        heading: 'Mauli Cabs:  Pune to Bhimashankar Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Bhimashankar cab services, ensuring a smooth and scenic journey to the revered Bhimashankar Temple, one of the twelve Jyotirlingas in India. Whether you’re visiting for religious purposes or to enjoy the natural beauty surrounding the area, we provide a variety of vehicles including sedans, SUVs, and premium cars to suit your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to customer satisfaction, Mauli Cabs guarantees a peaceful and hassle-free ride from Pune to Bhimashankar.',

        top: 'Top Places to Visit in Bhimashankar with Mauli Cabs',

"topPlaces": [
    {
        "title": "Bhimashankar Temple",
        "description": "Bhimashankar Temple is an ancient Hindu temple dedicated to Lord Shiva, located in the Sahyadri range. It is one of the 12 Jyotirlingas of Lord Shiva and an important pilgrimage site for devotees from across the country."
    },
    {
        "title": "Bhimashankar Wildlife Sanctuary",
        "description": "Bhimashankar Wildlife Sanctuary is a lush forest reserve that is home to a variety of flora and fauna, including the endangered Indian Giant Squirrel. The sanctuary offers scenic trekking trails and is a haven for nature lovers and wildlife enthusiasts."
    },
    {
        "title": "Gupta Bhimashankar",
        "description": "Gupta Bhimashankar is a hidden temple complex located about 2 km from the main Bhimashankar temple. It is an ancient and serene spot, believed to be the place where Lord Shiva meditated in secrecy."
    },
    {
        "title": "Hanuman Lake",
        "description": "Hanuman Lake is a small, picturesque lake located near the Bhimashankar temple. Surrounded by lush greenery, it is an ideal spot for a peaceful retreat and nature walks."
    },
    {
        "title": "Sahayadri Hills",
        "description": "The Sahayadri Hills surrounding Bhimashankar are known for their breathtaking views and scenic beauty. These hills are perfect for trekking and offer a serene escape from the city’s hustle."
    },
    {
        "title": "Kundalika River",
        "description": "The Kundalika River, located near Bhimashankar, offers opportunities for water sports such as rafting. The river flows through the scenic valley and is a popular spot for adventure enthusiasts."
    },
    {
        "title": "Madhavji Temple",
        "description": "Madhavji Temple is a beautiful temple dedicated to Lord Madhav, located near Bhimashankar. The temple is a quiet and peaceful spot for meditation and spiritual contemplation."
    },
    {
        "title": "Pillai’s Point",
        "description": "Pillai’s Point is a scenic viewpoint located on the way to Bhimashankar Temple. It offers a panoramic view of the surrounding hills, forests, and the valley below."
    },
    {
        "title": "Bhima Shankar Waterfall",
        "description": "Bhima Shankar Waterfall, located near Bhimashankar, is a beautiful natural waterfall that attracts visitors with its scenic surroundings. The waterfall is especially stunning during the monsoon season."
    },
    {
        "title": "Vishalgad Fort",
        "description": "Vishalgad Fort is located a little away from Bhimashankar, but it offers a historical charm and a chance to explore an ancient fort. It is ideal for trekking enthusiasts and history buffs alike."
    }
],

"services": [
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Book a reliable cab from Pune to Bhimashankar for a comfortable and smooth journey to the holy temple."
    },
    {
      "name": "Pune to Bhimashankar Taxi Fare",
      "description": "Get the details of the taxi fare for your trip from Pune to Bhimashankar, including the distance and charges."
    },
    {
      "name": "Pune to Bhimashankar Cab Fare",
      "description": "Know the affordable pricing options for a taxi from Pune to Bhimashankar and plan your trip accordingly."
    },
    {
      "name": "Taxi from Pune to Bhimashankar",
      "description": "Book a taxi for a safe and comfortable trip from Pune to Bhimashankar with well-maintained vehicles."
    },
    {
      "name": "Pune to Bhimashankar Cab Price",
      "description": "Check out the price details for the cab ride from Pune to Bhimashankar and ensure a budget-friendly experience."
    },
    {
      "name": "Book Cab from Pune to Bhimashankar",
      "description": "Easily book your cab from Pune to Bhimashankar online and ensure a hassle-free experience."
    },
    {
      "name": "Pune to Bhimashankar by Cab Charges",
      "description": "Get the exact charges for a taxi ride from Pune to Bhimashankar, including any additional fees."
    },
    {
      "name": "Pune to Bhimashankar Cab Booking",
      "description": "Book your Pune to Bhimashankar cab with us for a smooth and timely journey."
    },
    {
      "name": "Pune to Bhimashankar Cab Charges",
      "description": "Find the detailed charges for your Pune to Bhimashankar trip, including round trip or one-way journey options."
    },
    {
      "name": "Pune to Bhimashankar Cab Package",
      "description": "Choose from a range of Pune to Bhimashankar cab packages, including one-way, round-trip, and custom packages."
    },
    {
      "name": "Pune to Bhimashankar Car Rental",
      "description": "Rent a car from Pune to Bhimashankar for a flexible and comfortable ride. Choose from different vehicles as per your needs."
    },
    {
      "name": "Pune to Bhimashankar Taxi Service",
      "description": "Avail professional and reliable taxi services for your trip from Pune to Bhimashankar. Book in advance to secure your ride."
    },
    {
      "name": "Pune to Bhimashankar Taxi Price",
      "description": "Get the best taxi price for your journey from Pune to Bhimashankar with no hidden charges."
    },
    {
      "name": "Pune to Bhimashankar Temple Cab Fare",
      "description": "Check the fare details for a cab specifically for your temple visit to Bhimashankar."
    },
    {
      "name": "Pune to Bhimashankar Tempo Traveller",
      "description": "Rent a Tempo Traveller for a group trip to Bhimashankar. Ideal for families or groups, with ample space and comfort."
    },
    {
      "name": "Taxi Service from Pune to Bhimashankar",
      "description": "Opt for a reliable taxi service from Pune to Bhimashankar, with various vehicle options available to cater to your preferences."
    },
    {
      "name": "Pune to Bhimashankar Innova Crysta",
      "description": "Book an Innova Crysta for a comfortable and luxurious ride from Pune to Bhimashankar, suitable for families or groups."
    },
    {
      "name": "Pune to Bhimashankar Tempo Traveller",
      "description": "Rent a Tempo Traveller for a larger group journey from Pune to Bhimashankar, ensuring comfort and convenience for all passengers."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Cab", "Pune to Bhimashankar Taxi Fare"],
    ["Pune to Bhimashankar Cab Fare", "Taxi from Pune to Bhimashankar"],
    ["Pune to Bhimashankar Cab Price", "Book Cab from Pune to Bhimashankar"],
    ["Pune to Bhimashankar by Cab Charges", "Pune to Bhimashankar Cab Booking"],
    ["Pune to Bhimashankar Cab Charges", "Pune to Bhimashankar Cab Package"],
    ["Pune to Bhimashankar Car Rental", "Pune to Bhimashankar Taxi Service"],
    ["Pune to Bhimashankar Taxi Price", "Pune to Bhimashankar Temple Cab Fare"],
    ["Pune to Bhimashankar Tempo Traveller", "Taxi Service from Pune to Bhimashankar"],
    ["Pune to Bhimashankar Innova Crysta", "Pune to Bhimashankar Tempo Traveller"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Bhimashankar trip. Our professional drivers ensure punctual pickups and drop-offs, allowing you to enjoy a stress-free journey to this sacred temple without worrying about transport."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Bhimashankar journey, we provide comfortable and spacious vehicles. Whether you prefer a sedan, SUV, or premium car, all our vehicles are air-conditioned and well-maintained, offering you a relaxed and enjoyable ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are well-versed with the route from Pune to Bhimashankar. They ensure a smooth and safe journey by choosing the best routes and avoiding traffic, ensuring you arrive on time and safely."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides competitive and transparent pricing for your Pune to Bhimashankar trip. We ensure that there are no hidden charges, offering you the best value for money while maintaining the highest standards of service."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, ensuring a secure and smooth ride throughout your journey to Bhimashankar."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Bhimashankar trip. Whether you’re planning an early morning visit or a late-night return, our customer service team is always ready to assist you with booking and other travel arrangements."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Bhimashankar cab with Mauli Cabs is quick and easy. You can book online through our website or mobile app, or contact our customer service team for personalized assistance to ensure a smooth and hassle-free booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Bhimashankar journey. Whether you're traveling for a spiritual visit, family outing, or a group tour, we can tailor the service to suit your specific needs, ensuring a memorable experience."
    }
]






















    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Bhimashankar with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Bhimashankar with Mauli Cabs is simple! You can book directly through our website or mobile app by entering "Pune" as your pickup location and "Bhimashankar" as your destination. Choose your preferred vehicle, confirm the booking, and you’re good to go. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Bhimashankar trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your Pune to Bhimashankar journey, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your space and comfort preferences.',
        },
        {
            question: 'Is the fare for the Pune to Bhimashankar trip fixed?',
            answer: 'Yes, the fare for the Pune to Bhimashankar trip is fixed and transparent. The fare includes all charges such as tolls, taxes, driver fees, and other applicable charges. There are no hidden costs, and you will know the total fare upfront at the time of booking.',
        },
        {
            question: 'Can I book a round trip for the Pune to Bhimashankar journey?',
            answer: 'Yes, you can easily book a round trip from Pune to Bhimashankar. Simply provide your return details during booking, and we will ensure a smooth return journey for you.',
        },
        {
            question: 'How long does the journey from Pune to Bhimashankar take?',
            answer: 'The journey from Pune to Bhimashankar typically takes about 3.5 to 4 hours, depending on traffic and road conditions. The scenic route adds to the experience, making it a beautiful and enjoyable trip.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Bhimashankar trip?',
            answer: 'Yes, all Mauli Cabs drivers are highly professional, experienced, and familiar with the best routes to Bhimashankar. They ensure a safe and timely journey while prioritizing your comfort.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Bhimashankar?',
            answer: 'Yes, you can make stops during the journey for meals, refreshments, or sightseeing. Our drivers will accommodate any requests to ensure your journey is as comfortable and enjoyable as possible.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Bhimashankar trip?',
            answer: 'Yes, all our cabs are air-conditioned and thoroughly maintained to ensure a smooth and comfortable ride. We prioritize cleanliness and comfort for a pleasant journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Bhimashankar trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Bhimashankar trip. We offer flexible cancellation and modification policies via our website or app, and our customer support team is ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Bhimashankar trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, experienced drivers, and a commitment to ensuring your safety and comfort. Whether you’re traveling for pilgrimage, leisure, or business, we ensure a stress-free and enjoyable journey to Bhimashankar.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sandeep Kumar",
            position: "Devotee",
            text: "I booked a cab from Pune to Bhimashankar with Mauli Cabs, and the experience was amazing. The car was spacious, clean, and comfortable. The driver was courteous and knew the best route to avoid traffic. It was a peaceful and enjoyable ride. Highly recommend!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Sharma",
            position: "Pilgrim",
            text: "I traveled from Pune to Bhimashankar with Mauli Cabs, and it was a pleasant experience. The vehicle was very comfortable, and the air conditioning kept us cool throughout the trip. The driver was very professional, making sure we had a smooth journey. I will definitely book again.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Bhimashankar Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable taxi services for your journey from Pune to Bhimashankar. Choose from private cars, Innova Crysta, or Tempo Traveller for group travel. Book your cab easily and enjoy a comfortable, smooth ride to the Bhimashankar temple.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Bhimashankar Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Bhimashankar cab with Mauli Cabs. Enjoy reliable and affordable taxi services, whether you're going solo or in a group. Choose from private cabs, Innova Crysta, and Tempo Travellers for a comfortable ride to the Bhimashankar temple."
        />
        <meta
          name="keywords"
          content="Pune to Bhimashankar Cab, Pune to Bhimashankar Taxi Fare, Pune to Bhimashankar Cab Fare, Taxi from Pune to Bhimashankar, Pune to Bhimashankar Cab Price, Book Cab from Pune to Bhimashankar, Pune to Bhimashankar by Cab Charges, Pune to Bhimashankar Cab Booking, Pune to Bhimashankar Cab Charges, Pune to Bhimashankar Cab Package, Pune to Bhimashankar Car Rental, Pune to Bhimashankar Taxi Service, Pune to Bhimashankar Taxi Price, Pune to Bhimashankar Temple Cab Fare, Pune to Bhimashankar Tempo Traveller, Taxi Service from Pune to Bhimashankar, Pune to Bhimashankar Innova Crysta, Pune to Bhimashankar Tempo Traveller"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankarcab;